import React from "react";

const FaqItem = ({data}) => {

  return (
      <div className="py-8 2xl:py-12 px-6 2xl:px-10 bg-white shadow-md rounded-2xl overflow-hidden">
          {data?.faqTitle && (
            <div className={`text-2xl md:text-3xl 2xl:text-4xl font-black bg-clip-text text-transparent mb-5 bg-gradient-to-r max-w-sm ${data?.gradient}`}>
              {data.faqTitle}
            </div>
          )}
          {data?.faqDescription && (
              <div className="text-deep-purple text-base 2xl:text-lg max-w-sm" dangerouslySetInnerHTML={{ __html: data.faqDescription }}/>
          )}
      </div>
  );
};

export default FaqItem;
